import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { GetSalesforceDataService } from "app/services/salesforce-data";
import { SalesforceMapperService } from "app/services/salesforce-mapper.service";

@Component({
  selector: "app-brain-tech-robotics",
  templateUrl: "./brain-tech-robotics.component.html",
  styleUrls: ["./brain-tech-robotics.component.scss"],
})
export class BrainTechRoboticsComponent implements OnInit, OnDestroy {
  orgId!: string;
  organization: any;
  programs: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _getSalesforceDataService: GetSalesforceDataService,
    private salesforceMapper: SalesforceMapperService
  ) {}

  private storageListener = (event: StorageEvent) => {
    if (
      event.key === "cachedOrganizationData" ||
      event.key === "cachedProgramsData"
    ) {
      this.loadDataFromCache();
    }
  };

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.orgId = params["orgId"];
      this.loadDataFromCache();
    });

    window.addEventListener("storage", this.storageListener);
  }

  ngOnDestroy(): void {
    window.removeEventListener("storage", this.storageListener);
  }

  loadDataFromCache(): void {
    const orgCache = localStorage.getItem("cachedOrganizationData");
    const progCache = localStorage.getItem("cachedProgramsData");

    if (orgCache && progCache) {
      const orgs = JSON.parse(orgCache).data;
      const progs = JSON.parse(progCache).data;

      this.organization = orgs.find((o: any) => o.id === this.orgId);
      this.programs = progs.filter((p: any) => p.orgId === this.orgId);
    } else {
      this.fetchFromSalesforce();
    }
  }

  private fetchFromSalesforce(): void {
    this._getSalesforceDataService.getDataFromSalesforce1().subscribe(
      (response) => {
        if (response.success) {
          const dataSet = JSON.parse(response.msg);
          const orgs = dataSet.data.lstOrganizations || [];
          const progs = dataSet.data.lstPrograms || [];

          const mappedOrgs = this.salesforceMapper.mapOrganizations(orgs);
          const mappedProgs = this.salesforceMapper.mapPrograms(progs);

          localStorage.setItem(
            "cachedOrganizationData",
            JSON.stringify({ timestamp: Date.now(), data: mappedOrgs })
          );
          localStorage.setItem(
            "cachedProgramsData",
            JSON.stringify({ timestamp: Date.now(), data: mappedProgs })
          );

          this.organization = mappedOrgs.find((o: any) => o.id === this.orgId);
          this.programs = mappedProgs.filter(
            (p: any) => p.orgId === this.orgId
          );
        }
      },
      (err) => console.error("❌ Salesforce fetch failed", err)
    );
  }
  getRegularFee(fee: number): number {
    return fee + 50;
  }
  navigateToSignUp(programId: string, communityId: string): void {
    localStorage.setItem("ProgramId", programId);
    localStorage.setItem("communityId", communityId);
    this.router.navigate(["/sign-up"], {
      queryParams: { programId: programId, communityId: communityId },
    });
  }
}
